import { logger } from '../../../../utils/common/logger'
import { AuthInput } from '../../modules/auth-input'
import { LoginService } from '../loginradius/services/login-service'

export class BlockerPasswordlessEmailForm {
    private static DOM = {
        formId: 'blockerSendPasswordlessEmailForm'
    }
    private passwordlessSignInForm: HTMLFormElement

    /**
     * Listens for the form validated event in the send passwordless email form
     */
    public async init() {
        logger('debug', 'Initializing send passwordless email form')
        this.passwordlessSignInForm = document.querySelector(`#${BlockerPasswordlessEmailForm.DOM.formId}`)

        if (this.passwordlessSignInForm) {
            const prefillEmail = this.passwordlessSignInForm.dataset?.prefillEmail
            const editLinkUrl = this.passwordlessSignInForm.dataset.editLinkUrl
            const eventName = 'passwordless-login-email-input-edit'

            await AuthInput.initDOM(`#${BlockerPasswordlessEmailForm.DOM.formId}`, prefillEmail, editLinkUrl, eventName)
            this.passwordlessSignInForm.addEventListener(eventName, () => {
                LoginService.sendClickEvent(
                    'Edit Email', 'link', 'passwordless-login-form-email-input-edit',
                    location.href
                )
            })
        }
        logger('debug', 'Send passwordless email form initialized')
    }
}
